import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import ChatService from './service/ChatService';

const chatService = new ChatService();

export function connectWebSocket(url = chatService.getWebSocketUrl()) {
  return new Promise((res, rej) => {
    let socket = new Client({
      webSocketFactory: () => new SockJS(url),
      // debug: console.log,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    socket.beforeConnect = () => {
      const token = window.localStorage.getItem('token');
      if (!token) {
        socket.deactivate();
        rej(new Error('Authentication required for chat'));
        return;
      }
      socket.connectHeaders = { Authorization: `Bearer ${token}` };
    };
    socket.onStompError = () => {
      socket.deactivate();
      rej(new Error('Chat authentication or access denied'));
    };

    socket.onConnect = (frame) => res(socket);
    socket.activate();
  });
}

export async function connectChats(chats) {
  var socket = await connectWebSocket();
  chats.forEach(chat => chat.connect(socket));
  return [chats, socket];
}

export async function disconnectChats(chats, socket) {
  if (chats) chats.forEach(chat => chat.disconnect());
  if (socket) socket.deactivate();
}



// WEBPACK FOOTER //
// ./src/chat-utils.js